const initialState = {
  logosList: [],
  logosLoading: true,
  logosLoadingError: false,
  organizationsList: [],
  organizationsLoading: true,
  organizationsLoadingError: false,
  organizationActivePage: 1,
  deletingLogo: false,
  creatingLogo: false,
  organizationsToEdit: [],
  organizationFilter: '',
  editMultipleSelections: {},
  updatingOrganization: false,
};

const compare = (a, b) => {
  const orgA = a.organization_name.toUpperCase();
  const orgB = b.organization_name.toUpperCase();

  let comparison = 0;
  if (orgA > orgB) {
    comparison = 1;
  } else if (orgA < orgB) {
    comparison = -1;
  }
  return comparison;
};

// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ORG_ACTIVE_PAGE':
      return { ...state, organizationActivePage: action.payload };
    case 'SET_EDIT_MULTIPLE_SELECTION':
      return {
        ...state,
        editMultipleSelections: {
          [action.payload.id]: action.payload.value,
        },
      };
    case 'HANDLE_ORG_EDIT_CHECKBOX': {
      const { organization, checked } = action.payload;
      if (checked) {
        return {
          ...state,
          organizationsToEdit: [...state.organizationsToEdit, organization],
        };
      }
      if (!checked) {
        return {
          ...state,
          organizationsToEdit: state.organizationsToEdit
            .filter((org) => org.id !== organization.id),
        };
      }
      break;
    }
    case 'ADD_ORG_TO_EDIT': {
      const organization = action.payload;
      let present = false;
      state.organizationsToEdit.forEach((org) => {
        if (org.id === organization.id) {
          present = true;
        }
      });

      if (present) {
        return {
          ...state,
          organizationsToEdit: state.organizationsToEdit.map((org) => {
            if (org.id === organization.id) {
              if (action.logo_id === 'remove_from_store') {
                return null;
              }
              if (action.display_name === 'remove_from_store') {
                return null;
              }
              return {
                ...org,
                display_name: action.display_name === '' ? '' : action.display_name,
                logo_id: action.logo_id === '' ? undefined : action.logo_id,
              };
            }
            return org;
          }).filter((org) => org !== null),
        };
      }
      if (!present) {
        return {
          ...state,
          organizationsToEdit: [
            ...state.organizationsToEdit,
            {
              ...organization,
              display_name: action.display_name || undefined,
              logo_id: action.logo_id || undefined,
            },
          ],
        };
      }
      break;
    }
    case 'CLEAR_ORG_EDIT': {
      return { ...state, organizationsToEdit: [], editMultipleSelections: {} };
    }
    case 'SET_ORG_FILTER':
      return { ...state, organizationFilter: action.payload, organizationActivePage: 1 };
    case 'CREATING_LOGO':
      return { ...state, creatingLogo: action.payload };
    case 'DELETING_LOGO':
      return { ...state, deletingLogo: action.payload };
    case 'LOADING_LOGOS':
      return { ...state, logosLoading: true };
    case 'LOADING_LOGOS_ERROR':
      return { ...state, logosLoading: false, logosLoadingError: true };
    case 'LOAD_LOGOS':
      return {
        ...state,
        logosList: action.payload,
        logosLoading: false,
        logosLoadingError: false,
      };
    case 'LOADING_ORGANIZATIONS':
      return { ...state, organizationsLoading: true };
    case 'LOADING_ORGANIZATIONS_ERROR':
      return { ...state, organizationsLoading: false, organizationsLoadingError: true };
    case 'LOAD_ORGANIZATIONS': {
      return {
        ...state,
        organizationsList: action.payload.sort(compare),
        organizationsLoading: false,
        organizationsLoadingError: false,
      };
    }
    case 'UPDATING_ORGANIZATION':
      return { ...state, updatingOrganization: action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
